var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 20.6667V9.33333C22 9.12634 21.9526 8.92219 21.8614 8.73705C21.7703 8.55191 21.638 8.39086 21.475 8.26667L12.2875 1.26667C12.0603 1.09357 11.784 1 11.5 1C11.216 1 10.9397 1.09357 10.7125 1.26667L1.525 8.26667C1.36199 8.39086 1.22969 8.55191 1.13856 8.73705C1.04744 8.92219 1 9.12634 1 9.33333V20.6667C1 21.0203 1.13828 21.3594 1.38442 21.6095C1.63056 21.8595 1.9644 22 2.3125 22H7.5625C7.9106 22 8.24444 21.8595 8.49058 21.6095C8.73672 21.3594 8.875 21.0203 8.875 20.6667V16.6667C8.875 16.313 9.01328 15.9739 9.25942 15.7239C9.50556 15.4738 9.8394 15.3333 10.1875 15.3333H12.8125C13.1606 15.3333 13.4944 15.4738 13.7406 15.7239C13.9867 15.9739 14.125 16.313 14.125 16.6667V20.6667C14.125 21.0203 14.2633 21.3594 14.5094 21.6095C14.7556 21.8595 15.0894 22 15.4375 22H20.6875C21.0356 22 21.3694 21.8595 21.6156 21.6095C21.8617 21.3594 22 21.0203 22 20.6667Z",
    stroke: "#303438",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/home_icon.827192ee1fd949ec24c206b6c3dd9b71.svg";
export { ForwardRef as ReactComponent };